"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCountryId = exports.getCountriesSuccess = exports.getCountriesError = exports.getCountries = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    countries: [],
    areCountriesLoading: false,
    hasErrorLoadingCountries: false,
    selectedCountryId: "",
};
const countriesSlice = (0, toolkit_1.createSlice)({
    name: "countries",
    initialState,
    reducers: {
        getCountries: (state) => {
            state.areCountriesLoading = true;
        },
        getCountriesSuccess: (state, action) => {
            state.areCountriesLoading = false;
            state.countries = action.payload;
        },
        getCountriesError: (state) => {
            state.hasErrorLoadingCountries = true;
        },
        setCountryId: (state, action) => {
            state.selectedCountryId = action.payload;
        },
    },
});
_a = countriesSlice.actions, exports.getCountries = _a.getCountries, exports.getCountriesError = _a.getCountriesError, exports.getCountriesSuccess = _a.getCountriesSuccess, exports.setCountryId = _a.setCountryId;
exports.default = countriesSlice.reducer;
